import { FontSizeData_fontType } from './decoration_fontsize.enums';
export function fontSizeData_fontTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'PX':
            return FontSizeData_fontType.PX;
        case 1:
        case 'EM':
            return FontSizeData_fontType.EM;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return FontSizeData_fontType.UNRECOGNIZED;
    }
}
export function fontSizeData_fontTypeToJSON(object) {
    switch (object) {
        case FontSizeData_fontType.PX:
            return 'PX';
        case FontSizeData_fontType.EM:
            return 'EM';
        default:
            return 'UNKNOWN';
    }
}
const baseFontSizeData = { unit: FontSizeData_fontType.PX };
export const FontSizeData = {
    fromJSON(object) {
        const message = Object.assign({}, baseFontSizeData);
        message.unit =
            object.unit !== undefined && object.unit !== null
                ? fontSizeData_fontTypeFromJSON(object.unit)
                : FontSizeData_fontType.PX;
        message.value =
            object.value !== undefined && object.value !== null ? Number(object.value) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.unit !== undefined && (obj.unit = fontSizeData_fontTypeToJSON(message.unit));
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
};
//# sourceMappingURL=decoration_fontsize.js.map